<div class="cart-container">
  <button
    #overlayRef
    type="button"
    mat-icon-button
    color="primary"
    class="mat-icon-button-small"
    matBadgeSize="small"
    dynamicOverlay
    maxModalBreakPoint="st"
    overlayPanelClass="top-z-overlay"
    data-qa="cart-button"
    [title]="'Your cart'"
    [attr.data-qa-count]="itemsCount()"
    [attr.aria-label]="'Your cart' | translate"
    [matBadge]="itemsCount()"
    [matBadgeHidden]="!itemsCount()"
    [disableRipple]="true"
    [overlayTemplate]="overlayTemplateRef"
  >
    <mat-icon svgIcon="cart" color="white" />
  </button>
  <ng-template #overlayTemplateRef let-isModal="isModal">
    @if (isModal) {
      <div data-qa="cart-panel" [attr.data-qa-modal]="true">
        @if (itemsCount()) {
          <app-cart-content-view (closeEvent)="onClose()" />
        } @else {
          <div class="text-center font-medium p-3" data-qa="cart-empty">{{ 'Your cart is empty' | translate }}</div>
        }
      </div>
    } @else {
      <div class="cart-content" data-qa="cart-panel" [attr.data-qa-modal]="false">
        @if (itemsCount()) {
          <div class="text-center font-medium p-2" style="font-size: 1.15em" data-qa="cart-panel-title">
            {{ 'Your cart' | translate }} ({{ itemsCount() }})
          </div>
          <div class="h-[30rem]">
            <app-cart-content-view (closeEvent)="onClose()" />
          </div>
        } @else {
          <div class="text-center font-medium p-3" data-qa="cart-empty">{{ 'Your cart is empty' | translate }}</div>
        }
      </div>
    }
  </ng-template>
</div>
